// Plausible, only when VITE_PLAUSIBLE_DOMAIN is set; no cookies (SPEC §8.4).

import { pdfMode } from './pdf';

const DOMAIN: string | undefined = (import.meta as any).env?.VITE_PLAUSIBLE_DOMAIN;

export function initAnalytics() {
  if (!DOMAIN || typeof document === 'undefined' || pdfMode) return;
  const s = document.createElement('script');
  s.defer = true;
  s.dataset.domain = DOMAIN;
  s.src = 'https://plausible.io/js/script.manual.js';
  document.head.append(s);
  (window as any).plausible ??= function (...a: unknown[]) { ((window as any).plausible.q ??= []).push(a); };
}

export type TrackEvent =
  | 'report_started' | 'report_done' | 'report_failed' | 'quote_submitted' | 'print' | 'pageview'
  | 'search_mode' | 'example_click' | 'demo_click' | 'cta_view' | 'cta_click' | 'form_start'
  | 'report_emailed' | 'pdf_emailed' | 'print_gate' | 'waitlist_submitted' | 'savings_adjust' | 'share' | 'roof_select';

export function track(event: TrackEvent, props?: Record<string, string>) {
  if (!DOMAIN || pdfMode) return; // the PDF renderer is not a visitor
  try { (window as any).plausible?.(event, props ? { props } : undefined); } catch { /* ignore */ }
}

export const durationBucket = (ms: number) => (ms < 5000 ? '<5s' : ms < 10000 ? '5-10s' : ms < 15000 ? '10-15s' : ms < 30000 ? '15-30s' : '>30s');
